module.exports = __webpack_public_path__ + "media/images/icon/icons8-Questions-722767d303ef5739aba4ab38baf2d5ee.png";